<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import chartResize from "./mixins/chart-resize";

export default {
  name: 'GaugeEchart',
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "仪表盘",
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "日期",
    },
    yAxisName: {
      type: String,
      default: "数量",
    },
    //仪表盘刻度的分割段数。
    splitNumber:{
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.chart.clear();
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        title: {
          text: this.title,
          textStyle: {
            fontSize: 16,
            color: "#c0c3cd",
          },
        },
        legend: {
          show: false,
        },
        grid: {
          top: 35,
          left: "3%",
          right: "6%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          show: false,
          type: "category",
        },
        yAxis: {
          show: false,
          type: "value",
        },
        series: [
          {
            name: this.title,
            type: "gauge",
            radius: "90%",
            min: 0,
            max: this.chartData.maxData,
            splitNumber: this.splitNumber,
            startAngle: 180,
            endAngle: 0,
            zlevel: 0,
            data: [
              {
                value: this.chartData.data,
                name: this.title,
                itemStyle: {
                  color: "#fff",
                },
              },
            ],
            legend: {
              padding: 0,
              margin: 0,
            },
            pointer: {
              show: true,
              length: "80%",
              radius: "50%",
              width: 10, //指针粗细
            },
            title: {
              text: this.title,
              // 仪表盘标题。
              show: false, // 是否显示标题,默认 true。
            },
            markLine: {
              precision: 2,
            },
            axisTick: {
              show: false,
              splitNumber: 5,
              lineStyle: {
                width: 2,
              },
              length: -8,
            }, //刻度样式
            splitLine: {
              show: true,
              length: -10,
              lineStyle: {
                color: "#233446", //用颜色渐变函数不起作用
              },
            }, //分隔线样式
            axisLabel: {
              show: true,
              distance: this.chartData.data>1000?-40:-20,
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 20, // 仪表盘宽度
                color: [
                  [0.2, "#eaba5f"],
                  [0.8, "#0adbfa"],
                  [1, "#2ca1ff"],
                ],
              },
            },
          },
        ],
      });
    },
  },
};
</script>
